export const noChange = 'No Change'

export const blankForm = {
    sectionNames: { value: '', valid: true },
    productType: { value: '', valid: true },
    isActive: { value: 'Active', valid: true },
    listingType: { value: noChange, valid: true },
    state: { value: noChange, valid: true },
    includeManufacturerOptions: { value: 'true', valid: true },
    specAgentProductTypeId: { value: '', valid: true },
}
